import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-filter-result-box',
    templateUrl: './filter-result-box.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class FilterResultBoxComponent {}
